import { render } from "./Composite.vue?vue&type=template&id=01b50b45"
import script from "./Composite.vue?vue&type=script&lang=js"
export * from "./Composite.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__